export const CONFIG = {
  logo: "/logo.png",
  site_title: "AirAgri Management",
  Auth0Domain: "airagri.au.auth0.com",
  Auth0ClientId: "0C2UEDV0lr6Pu67XS1geq21pl0a6dQt2",
  Auth0Audience: "https://management.api.airagri.tech",
  API_URL: "https://loramanagement.api.airagri.tech/",
  mapboxAccessToken:
    "pk.eyJ1IjoiYmZnbmVpbCIsImEiOiJjbGR2azExeW4wZ28yM29tZm4xZjJwdHFxIn0.Mdv--BkZwKSw-pdTRMQdPg",
  mapStyle: "mapbox://styles/bfgneil/clkha3odl008i01qpeqws6d21",
  websiteURL: "https://loramanagement.airagri.tech", // Update to your website URL
  billingEnabled: false,
  deviceCost: 15,
  primaryColour: "#009bd6",
  secondaryColour: "#00415a",
};
